
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";


@Injectable()
export class InTransactionsService {

  constructor(private auth: AuthenticationService, private http: Http) { }



  //--------------Transfer-----------------//
  GetTransfer(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Transfer",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  GetTransferById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Transfer_byId",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTransferByVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Transfer_byVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetVoucherType(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_VoucherType",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTransferByDate(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Transfer_byDate",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetTransferByFromLocation(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Transfer_byFromLocation",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getToLocation(Model: any) {

    return this.http
      .post(
        this.auth.baseUrl +
        "/services/api/v1/Get_ToLocation", Model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });

  }
  SaveTransfer(Transfer_Master: any) {
    if (Transfer_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Transfer",
          Transfer_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Transfer",
          Transfer_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteTransfer(Id: any) {
    if (Id != 0) {
      return this.http
        .delete(
          this.auth.baseUrl + "/services/api/v1/Delete_Transfer?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  allowTransaction(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/AllowTansaction",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_PendingTransferList(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PendingTransferList",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_Transfer_Status(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_Transfer_Status",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Load_MobilePDTFromTransfer(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Load_MobilePDTFromTransfer",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------Transfer-----------------//

  //--------------STOCK ADJUSTMENT-----------------//

  Getstock(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_StockAdjustment",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  loadOnline(LocationId: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Loadonline?LocationId=" + LocationId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  process(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Process",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  getStockNo() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_StockNo",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getStockadjustmentById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_StockadjustmentById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveStockAdjustment(StockAdjustment_Master: any) {
    if (StockAdjustment_Master.ID == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/SaveStockAdjustment",
          StockAdjustment_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/UpdateStockAdjustment",
          StockAdjustment_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteStock(Id: any) {
    if (Id != 0) {
      return this.http
        .delete(
          this.auth.baseUrl + "/services/api/v1/Delete_Stock?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  Get_VarianceReportData(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_VarianceReportData",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }


  //--------------STOCK ADJUSTMENT-----------------//
  //--------------Damage-----------------//
  getDamage(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Damage",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  getDamageById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Damage_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Savedamage(Transfer_Master: any) {
    if (Transfer_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Damage",
          Transfer_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Damage",
          Transfer_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  GetDamageByVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Transfer_byVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  DeleteDamage(Id: any) {

    if (Id != 0) {
      return this.http
        .delete(
          this.auth.baseUrl + "/services/api/v1/Delete_Damage?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  Get_PDTDamageSearch(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PDTDamageSearch",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_DamagefromMobilePDT(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DamagefromMobilePDT",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Damage-----------------//
  //--------------Transfer-----------------//
  getRepacking(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Repacking",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getRepackingById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_RepackingById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveRepacking(Repacking_Master: any) {
    if (Repacking_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Repacking",
          Repacking_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Repacking",
          Repacking_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteRepacking(Id: any) {

    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Delete_Repacking?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  //--------------Repacking-----------------//
  //--------------Production-----------------//
  getProduction(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Production",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getProductionById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductionById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveProduction(Production_Master: any) {
    if (Production_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Production",
          Production_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Production",
          Production_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteProduction(Id: any) {

    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Delete_Production?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  LoadLastRawMaterial(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/LoadLastRawMaterial",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveFinishedGoods(Body: any) {
    if (Body.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_FinishedGoods",
          Body,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_FinishedGoods",
          Body,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getFinishedGoodsById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_FinishedGoodsById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Production-----------------//
  //--------------Material Requisition-----------------//
  getMaterialRequisition(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_MaterialRequisition",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getMaterialRequisitioVoucherNon(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_MaterialVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getMaterialRequisitionById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_MaterialRequisitionById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveMaterialRequisition(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/save_MaterialRequisition",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  updateMaterialRequisition(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_MaterialRequisition",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteMaterialRequisition(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_MaterialRequisition",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getMaterialRequisitionByVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_MaterialRequisitionByVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getRequisitionSearch(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_RequisitionSearch",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_RequisitionStatus(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_RequisitionStatus",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Material Requisition-----------------//
  //--------------Production Consumption-----------------//
  Save_ProductionConsumption(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_ProductionConsumption",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ProductionConsumptionList(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductionConsumptionList",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ProductionConsumptionById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductionConsumptionById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_ProductionConsumption(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_ProductionConsumption",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ProductionConsumptionMaster(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductionConsumptionMaster",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Production Consumption-----------------//
  //--------------Cost Adjustment-----------------------//
  Get_CostAdjustment(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CostAdjustment",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_CostAdjustmentById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CostAdjustmentById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_CostAdjustment(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_CostAdjustment",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_CostAdjustment(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_CostAdjustment",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_CostAdjustment(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_CostAdjustment",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_CostAdjustmentNo() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_CostAdjustmentNo",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_CostForCostAdjustment(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CostForCostAdjustment",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Cost Adjustment-----------------------//

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/inventory/in-transactions.service.ts